import { Component, ElementRef, Input, ViewChild, ViewEncapsulation } from '@angular/core';
import { HttpService } from '../../services/http-service/http.service';
import { StorageService } from '../../services/storege-service/storage.service';
import { ToolService } from '../../services/tool/tool.service';
import { BsDropdownDirective } from 'ngx-bootstrap/dropdown';

@Component({
  selector: 'app-notifications',
  templateUrl: './notifications.component.html',
  styleUrls: ['./notifications.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class NotificationsComponent {

  @ViewChild(BsDropdownDirective, { static: false }) dropdown: BsDropdownDirective;

  constructor(
    private httpService: HttpService,
    private storageSrv: StorageService,
    public toolService: ToolService,
  ) {
  }

  notifications: any[] = [];
  isLoading: boolean = true;

  ngOnInit(): void {
    this.getFacilityActivities();
    this.storageSrv.facilityIdSubject.subscribe((resp: any) => {
      this.getFacilityActivities(resp);
    })
  }

  onToggleNotifications() {
    // const isDropdownOpen = this.dropdown.isOpen;
    // if (isDropdownOpen) {
    //   this.getFacilityActivities();
    // }
  }

  async getFacilityActivities(facilityId?: any) {
    this.isLoading = true;
    const myFacilityId = facilityId ? facilityId : this.storageSrv.getFacilityId()
    var fd = new FormData();
    fd.append('facilityId', myFacilityId);
    return await this.httpService.post('getFacilityActivity', fd, '')
      .then(
        data => {
          this.notifications = data?.content ?? [];
          this.isLoading = false;
        },
        error => {
        }
      ).catch();
  }


}
